import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { FormattedNumber } from 'react-intl';

import RawButton from '@swf/components/StarsButton/RawButton';
import Cvl2Panels from '@swf/components/StarsRewards/components/Cvl2Panels/Cvl2Panels';
import PanelItem from '@swf/components/StarsRewards/components/PanelItem/PanelItem';
import PanelItemInfo from '@swf/components/StarsRewards/components/PanelItemInfo/PanelItemInfo';
import type { RewardsStateModel } from '@swf/core/types/RewardsLegacy';

import BoostIcon from '../../assets/boost.svg';
import DropIcon from '../../assets/drop.svg';
import styles from '../PanelDropDown/PanelDropDown.scss';

import {
  TXTCLI_Boost_on_for_next_N0_points,
  TXTCLI_Boosts_double_the_rate_at_whic_ELL,
  TXTCLI_N0___N1_points,
  TXTCLI_Open_Chest,
  TXTCLI_Open_Chests,
  TXTCLI_To_win_a_ChestX_fill_your_prog_ELL,
  TXTINT_FORMAT_LongTime
} from './DetailsPanels.messages.json';

interface Props {
  showExchange: () => void;
  onOpenChestClick: () => void;
  data: RewardsStateModel;
}

interface State {
  panelId?: number;
  panelOpened: boolean;
}

class DetailsPanels extends React.PureComponent<Props, State> {
  state = {
    panelId: undefined,
    panelOpened: false
  };

  togglePanel = (panelId: number) => {
    this.setState((prevState) => ({
      panelId,
      panelOpened:
        prevState.panelOpened === this.state.panelOpened && prevState.panelId === panelId
          ? !prevState.panelOpened
          : true
    }));
  };

  formatNumber = (value: number) => <FormattedNumber style="decimal" value={value} />;

  formatTime = (time: { minutes: number; hours: number }) => (
    <Translation {...TXTINT_FORMAT_LongTime} values={{ 0: time.hours, 1: time.minutes }} />
  );

  render() {
    const {
      showExchange,
      onOpenChestClick,
      data: {
        tierId,
        boostRemaining,
        chestsCount,
        currentPoints,
        showTierUp,
        targetPoints,
        cvlConfig,
        goingToTierDown,
        goingToTierUp
      }
    } = this.props;

    return (
      <>
        <PanelItem
          panelId={1}
          isOpened={this.state.panelOpened}
          selectedPanelId={this.state.panelId}
          hasInfo
          togglePanel={this.togglePanel}
        >
          <DropIcon
            className={
              cvlConfig?.cvl2 && goingToTierDown
                ? styles.red
                : showTierUp || goingToTierUp
                ? styles.blue
                : undefined
            }
          />
          <Translation
            {...TXTCLI_N0___N1_points}
            values={{
              0: this.formatNumber(currentPoints),
              1: this.formatNumber(targetPoints)
            }}
          />

          <PanelItemInfo>
            <Translation {...TXTCLI_To_win_a_ChestX_fill_your_prog_ELL} />
          </PanelItemInfo>
        </PanelItem>

        {boostRemaining > 0 && (
          <PanelItem
            panelId={2}
            isOpened={this.state.panelOpened}
            selectedPanelId={this.state.panelId}
            hasInfo
            togglePanel={this.togglePanel}
          >
            <BoostIcon />
            <Translation
              {...TXTCLI_Boost_on_for_next_N0_points}
              values={{ 0: this.formatNumber(boostRemaining) }}
            />

            <PanelItemInfo>
              <Translation {...TXTCLI_Boosts_double_the_rate_at_whic_ELL} />
            </PanelItemInfo>
          </PanelItem>
        )}

        {cvlConfig?.cvl2 && (
          <Cvl2Panels
            togglePanel={this.togglePanel}
            showExchange={showExchange}
            selectedPanelId={this.state.panelId}
            panelOpened={this.state.panelOpened}
            data={{ cvlConfig, tierId, goingToTierDown }}
          />
        )}
        {chestsCount !== 0 && (
          <PanelItem panelId={6}>
            <RawButton
              variant="primary"
              size="small"
              className={styles.chests}
              onClick={onOpenChestClick}
            >
              <Translation
                {...(chestsCount === 1 ? TXTCLI_Open_Chest : TXTCLI_Open_Chests)}
                values={{ 0: chestsCount }}
              />{' '}
              ({chestsCount})
            </RawButton>
          </PanelItem>
        )}
      </>
    );
  }
}

export default DetailsPanels;
